export const mainActionTypes = {
    // FETCH DIAGRAMS LIST
    MAIN_FETCH_DIAGRAMS_LIST_REQUEST: 'M1',
    MAIN_FETCH_DIAGRAMS_LIST_SUCCESS: 'M2',
    MAIN_FETCH_DIAGRAMS_LIST_FAILURE: 'M3',

    // FETCH TEMPLATES LIST
    MAIN_FETCH_TEMPLATES_LIST_REQUEST: 'M4',
    MAIN_FETCH_TEMPLATES_LIST_SUCCESS: 'M5',
    MAIN_FETCH_TEMPLATES_LIST_FAILURE: 'M6',

    // DIAGRAM RENAME
    TOGGLE_MODAL_DIAGRAM_RENAME: 'M7',
    MAIN_DIAGRAM_RENAME_REQUEST: 'M8',
    MAIN_DIAGRAM_RENAME_SUCCESS: 'M9',
    MAIN_DIAGRAM_RENAME_FAILURE: 'M10',

    // DIAGRAM CLONE
    TOGGLE_MODAL_DIAGRAM_CLONE: 'M11',
    MAIN_DIAGRAM_CLONE_REQUEST: 'M12',
    MAIN_DIAGRAM_CLONE_SUCCESS: 'M13',
    MAIN_DIAGRAM_CLONE_FAILURE: 'M14',

    // DIAGRAM SOFT DELETE (ARCHIVE)
    TOGGLE_MODAL_DIAGRAM_SOFT_DELETE: 'M15',
    MAIN_DIAGRAM_SOFT_DELETE_REQUEST: 'M16',
    MAIN_DIAGRAM_SOFT_DELETE_SUCCESS: 'M17',
    MAIN_DIAGRAM_SOFT_DELETE_FAILURE: 'M18',

    MAIN_CLEAR_DIAGRAM_ERRORS: 'M19',

    // DIAGRAM DELETE
    TOGGLE_MODAL_DIAGRAM_DELETE: 'M20',
    MAIN_DIAGRAM_DELETE_REQUEST: 'M21',
    MAIN_DIAGRAM_DELETE_SUCCESS: 'M22',
    MAIN_DIAGRAM_DELETE_FAILURE: 'M23',

    // DIAGRAM RESTORE
    TOGGLE_MODAL_DIAGRAM_RESTORE: 'M24',
    MAIN_DIAGRAM_RESTORE_REQUEST: 'M25',
    MAIN_DIAGRAM_RESTORE_SUCCESS: 'M26',
    MAIN_DIAGRAM_RESTORE_FAILURE: 'M27',

    // DIAGRAM SHARE
    TOGGLE_MODAL_DIAGRAM_SHARE: 'M28',
    MAIN_DIAGRAM_SHARE_REQUEST: 'M29',
    MAIN_DIAGRAM_SHARE_SUCCESS: 'M30',
    MAIN_DIAGRAM_SHARE_FAILURE: 'M31',

    // DIAGRAM PIN TOGGLE (was STAR — backend renamed star → pin, 2026-08)
    MAIN_DIAGRAM_PIN_TOGGLE_REQUEST: 'M82',
    MAIN_DIAGRAM_PIN_TOGGLE_SUCCESS: 'M83',
    MAIN_DIAGRAM_PIN_TOGGLE_FAILURE: 'M84',


    // TEMPLATE CLONE
    TOGGLE_MODAL_TEMPLATE_CLONE: 'M32',
    MAIN_TEMPLATE_CLONE_REQUEST: 'M33',
    MAIN_TEMPLATE_CLONE_SUCCESS: 'M34',
    MAIN_TEMPLATE_CLONE_FAILURE: 'M35',

    // SIDEBAR
    TOGGLE_SIDEBAR_PROFILE_MENU: 'M37',

    // PRICING PLAN
    ENABLE_MODAL_PRICING_PLAN_LIMIT: 'M38',
    TOGGLE_MODAL_PRICING_PLAN_UPGRADE: 'M39',
    PRICING_PLAN_UPGRADE_REQUEST: 'M40',
    PRICING_PLAN_UPGRADE_SUCCESS: 'M41',
    PRICING_PLAN_UPGRADE_FAILURE: 'M42',

    // DIAGRAM CREATE
    TOGGLE_MODAL_DIAGRAM_CREATE: 'M43',
    TOGGLE_MODAL_DIAGRAM_CREATE_NEW: 'M44',
    DIAGRAM_CREATE_REQUEST: 'M45',
    DIAGRAM_CREATE_SUCCESS: 'M46',
    DIAGRAM_CREATE_FAILURE: 'M47',

    // DIAGRAM IMPORT SQL
    TOGGLE_MODAL_DIAGRAM_IMPORT_SQL: 'M48',

    // DIAGRAM/TEMPLATE DETAILS
    TOGGLE_MODAL_DIAGRAM_DETAILS: 'M49',
    TOGGLE_MODAL_TEMPLATE_DETAILS: 'M50',

    // SUPPORT
    TOGGLE_MODAL_SUPPORT: 'M51',
    SUPPORT_REQ_REQUEST: 'M52',
    SUPPORT_REQ_SUCCESS: 'M53',
    SUPPORT_REQ_FAILURE: 'M54',
    MAIN_CLEAR_FEEDBACK_SENT_STATUS: 'M55',

    TOGGLE_MODAL_FEEDBACK_THANKS: 'M56',

    // INVITE PEOPLE
    TOGGLE_MODAL_INVITE_PEOPLE: 'M57',
    INVITE_PEOPLE_REQUEST: 'M58',
    INVITE_PEOPLE_SUCCESS: 'M59',
    INVITE_PEOPLE_FAILURE: 'M60',
    MAIN_CLEAR_INVITE_SENT_STATUS: 'M61',

    MOVE_TO_CANVAS: 'M62',
    MAIN_CANVAS_STARTED: 'M63',

    MAIN_FETCH_DIAGRAM_REQUEST: 'M64',
    MAIN_FETCH_DIAGRAM_SUCCESS: 'M65',
    MAIN_FETCH_DIAGRAM_FAILURE: 'M66',

    DISABLE_MODAL_PRICING_PLAN_LIMIT: 'M67',

    LOAD_NEW_PROJECT: 'M75',
    // LOAD_SAMPLE_PROJECT_DETAILS: 'M76',

    TOGGLE_MODAL_LANGUAGES: 'M79',

    TOGGLE_MODAL_WORKSPACE_CREATE: 'M80',

    TOGGLE_SIDEBAR_WORKSPACE_MENU: 'M81',

    TOGGLE_MODAL_WORKSPACE_LEAVE: 'M85',

    TOGGLE_MODAL_WORKSPACE_DELETE: 'M86',

    TOGGLE_MODAL_MEMBER_REMOVE: 'M87',

    TOGGLE_MODAL_INVITE_REVOKE: 'M88',
};











// export const mainActionTypes = {
//     // FETCH DIAGRAMS LIST
//     MAIN_FETCH_DIAGRAMS_LIST_REQUEST: 'MAIN_FETCH_DIAGRAMS_LIST_REQUEST',
//     MAIN_FETCH_DIAGRAMS_LIST_SUCCESS: 'MAIN_FETCH_DIAGRAMS_LIST_SUCCESS',
//     MAIN_FETCH_DIAGRAMS_LIST_FAILURE: 'MAIN_FETCH_DIAGRAMS_LIST_FAILURE',

//     // FETCH TEMPLATES LIST
//     MAIN_FETCH_TEMPLATES_LIST_REQUEST: 'MAIN_FETCH_TEMPLATES_LIST_REQUEST',
//     MAIN_FETCH_TEMPLATES_LIST_SUCCESS: 'MAIN_FETCH_TEMPLATES_LIST_SUCCESS',
//     MAIN_FETCH_TEMPLATES_LIST_FAILURE: 'MAIN_FETCH_TEMPLATES_LIST_FAILURE',

//     // DIAGRAM RENAME
//     TOGGLE_MODAL_DIAGRAM_RENAME: 'TOGGLE_MODAL_DIAGRAM_RENAME',
//     MAIN_DIAGRAM_RENAME_REQUEST: 'MAIN_DIAGRAM_RENAME_REQUEST',
//     MAIN_DIAGRAM_RENAME_SUCCESS: 'MAIN_DIAGRAM_RENAME_SUCCESS',
//     MAIN_DIAGRAM_RENAME_FAILURE: 'MAIN_DIAGRAM_RENAME_FAILURE',

//     // DIAGRAM CLONE
//     TOGGLE_MODAL_DIAGRAM_CLONE: 'TOGGLE_MODAL_DIAGRAM_CLONE',
//     MAIN_DIAGRAM_CLONE_REQUEST: 'MAIN_DIAGRAM_CLONE_REQUEST',
//     MAIN_DIAGRAM_CLONE_SUCCESS: 'MAIN_DIAGRAM_CLONE_SUCCESS',
//     MAIN_DIAGRAM_CLONE_FAILURE: 'MAIN_DIAGRAM_CLONE_FAILURE',

//     // DIAGRAM SOFT DELETE (ARCHIVE)
//     TOGGLE_MODAL_DIAGRAM_SOFT_DELETE: 'TOGGLE_MODAL_DIAGRAM_SOFT_DELETE',
//     MAIN_DIAGRAM_SOFT_DELETE_REQUEST: 'MAIN_DIAGRAM_SOFT_DELETE_REQUEST',
//     MAIN_DIAGRAM_SOFT_DELETE_SUCCESS: 'MAIN_DIAGRAM_SOFT_DELETE_SUCCESS',
//     MAIN_DIAGRAM_SOFT_DELETE_FAILURE: 'MAIN_DIAGRAM_SOFT_DELETE_FAILURE',

//     MAIN_CLEAR_DIAGRAM_ERRORS: 'MAIN_CLEAR_DIAGRAM_ERRORS',

//     // DIAGRAM DELETE
//     TOGGLE_MODAL_DIAGRAM_DELETE: 'TOGGLE_MODAL_DIAGRAM_DELETE',
//     MAIN_DIAGRAM_DELETE_REQUEST: 'MAIN_DIAGRAM_DELETE_REQUEST',
//     MAIN_DIAGRAM_DELETE_SUCCESS: 'MAIN_DIAGRAM_DELETE_SUCCESS',
//     MAIN_DIAGRAM_DELETE_FAILURE: 'MAIN_DIAGRAM_DELETE_FAILURE',

//     // DIAGRAM RESTORE
//     TOGGLE_MODAL_DIAGRAM_RESTORE: 'TOGGLE_MODAL_DIAGRAM_RESTORE',
//     MAIN_DIAGRAM_RESTORE_REQUEST: 'MAIN_DIAGRAM_RESTORE_REQUEST',
//     MAIN_DIAGRAM_RESTORE_SUCCESS: 'MAIN_DIAGRAM_RESTORE_SUCCESS',
//     MAIN_DIAGRAM_RESTORE_FAILURE: 'MAIN_DIAGRAM_RESTORE_FAILURE',

//     // DIAGRAM SHARE
//     TOGGLE_MODAL_DIAGRAM_SHARE: 'TOGGLE_MODAL_DIAGRAM_SHARE',
//     MAIN_DIAGRAM_SHARE_REQUEST: 'MAIN_DIAGRAM_SHARE_REQUEST',
//     MAIN_DIAGRAM_SHARE_SUCCESS: 'MAIN_DIAGRAM_SHARE_SUCCESS',
//     MAIN_DIAGRAM_SHARE_FAILURE: 'MAIN_DIAGRAM_SHARE_FAILURE',


//     // TEMPLATE CLONE
//     TOGGLE_MODAL_TEMPLATE_CLONE: 'TOGGLE_MODAL_TEMPLATE_CLONE',
//     MAIN_TEMPLATE_CLONE_REQUEST: 'MAIN_TEMPLATE_CLONE_REQUEST',
//     MAIN_TEMPLATE_CLONE_SUCCESS: 'MAIN_TEMPLATE_CLONE_SUCCESS',
//     MAIN_TEMPLATE_CLONE_FAILURE: 'MAIN_TEMPLATE_CLONE_FAILURE',

//     // SIDEBAR
//     TOGGLE_SIDEBAR_COLLAPSE: 'TOGGLE_SIDEBAR_COLLAPSE',
//     TOGGLE_SIDEBAR_PROFILE_MENU: 'TOGGLE_SIDEBAR_PROFILE_MENU',

//     // PRICING PLAN
//     ENABLE_MODAL_PRICING_PLAN_LIMIT: 'ENABLE_MODAL_PRICING_PLAN_LIMIT',
//     TOGGLE_MODAL_PRICING_PLAN_UPGRADE: 'TOGGLE_MODAL_PRICING_PLAN_UPGRADE',
//     PRICING_PLAN_UPGRADE_REQUEST: 'PRICING_PLAN_UPGRADE_REQUEST',
//     PRICING_PLAN_UPGRADE_SUCCESS: 'PRICING_PLAN_UPGRADE_SUCCESS',
//     PRICING_PLAN_UPGRADE_FAILURE: 'PRICING_PLAN_UPGRADE_FAILURE',

//     // DIAGRAM CREATE
//     TOGGLE_MODAL_DIAGRAM_CREATE: 'TOGGLE_MODAL_DIAGRAM_CREATE',
//     TOGGLE_MODAL_DIAGRAM_CREATE_NEW: 'TOGGLE_MODAL_DIAGRAM_CREATE_NEW',
//     DIAGRAM_CREATE_REQUEST: 'DIAGRAM_CREATE_REQUEST',
//     DIAGRAM_CREATE_SUCCESS: 'DIAGRAM_CREATE_SUCCESS',
//     DIAGRAM_CREATE_FAILURE: 'DIAGRAM_CREATE_FAILURE',

//     // DIAGRAM IMPORT SQL
//     TOGGLE_MODAL_DIAGRAM_IMPORT_SQL: 'TOGGLE_MODAL_DIAGRAM_IMPORT_SQL',

//     // DIAGRAM/TEMPLATE DETAILS
//     TOGGLE_MODAL_DIAGRAM_DETAILS: 'TOGGLE_MODAL_DIAGRAM_DETAILS',
//     TOGGLE_MODAL_TEMPLATE_DETAILS: 'TOGGLE_MODAL_TEMPLATE_DETAILS',

//     // SUPPORT
//     TOGGLE_MODAL_SUPPORT: 'TOGGLE_MODAL_SUPPORT',
//     SUPPORT_REQ_REQUEST: 'SUPPORT_REQ_REQUEST',
//     SUPPORT_REQ_SUCCESS: 'SUPPORT_REQ_SUCCESS',
//     SUPPORT_REQ_FAILURE: 'SUPPORT_REQ_FAILURE',
//     MAIN_CLEAR_FEEDBACK_SENT_STATUS: 'MAIN_CLEAR_FEEDBACK_SENT_STATUS',

//     TOGGLE_MODAL_FEEDBACK_THANKS: 'TOGGLE_MODAL_FEEDBACK_THANKS',

//     // INVITE PEOPLE
//     TOGGLE_MODAL_INVITE_PEOPLE: 'TOGGLE_MODAL_INVITE_PEOPLE',
//     INVITE_PEOPLE_REQUEST: 'INVITE_PEOPLE_REQUEST',
//     INVITE_PEOPLE_SUCCESS: 'INVITE_PEOPLE_SUCCESS',
//     INVITE_PEOPLE_FAILURE: 'INVITE_PEOPLE_FAILURE',
//     MAIN_CLEAR_INVITE_SENT_STATUS: 'MAIN_CLEAR_INVITE_SENT_STATUS',

//     MOVE_TO_CANVAS: 'MOVE_TO_CANVAS',
//     MAIN_CANVAS_STARTED: 'MAIN_CANVAS_STARTED',

//     MAIN_FETCH_DIAGRAM_REQUEST: 'MAIN_FETCH_DIAGRAM_REQUEST',
//     MAIN_FETCH_DIAGRAM_SUCCESS: 'MAIN_FETCH_DIAGRAM_SUCCESS',
//     MAIN_FETCH_DIAGRAM_FAILURE: 'MAIN_FETCH_DIAGRAM_FAILURE',

//     DISABLE_MODAL_PRICING_PLAN_LIMIT: 'DISABLE_MODAL_PRICING_PLAN_LIMIT',

//     LOAD_NEW_PROJECT: 'LOAD_NEW_PROJECT',
//     LOAD_SAMPLE_PROJECT_DETAILS: 'LOAD_SAMPLE_PROJECT_DETAILS',

//     TOGGLE_MODAL_LANGUAGES: 'TOGGLE_MODAL_LANGUAGES',

//     TOGGLE_MODAL_WORKSPACE_CREATE: 'TOGGLE_MODAL_WORKSPACE_CREATE',

//     TOGGLE_SIDEBAR_WORKSPACE_MENU: 'TOGGLE_SIDEBAR_WORKSPACE_MENU',
// };


